import { getCurrentInstance, ref } from "vue";

import { logError } from "@Helpers/logger";

import useNotify from "@Composables/useNotify";
import { XShoppingCartStore } from "@Modules/shoppingcart/Store/XShoppingCartStore";

export default function useAuth() {
  const { notifyError } = useNotify();

  const $vm = getCurrentInstance()?.proxy;

  const isLoggingOut = ref(false);
  const refreshState = () => $vm.$store.dispatch("refreshState");
  const shoppingCartStore = XShoppingCartStore();
  const clearShoppingCart = () => shoppingCartStore.clearCart();

  /**
   * Processes the successful logout.
   */
  function processLogout(logoutCallback = () => {}) {
    clearShoppingCart();
    localStorage.setItem("stateStatus", false);
    isLoggingOut.value = false;

    $vm.$router
      .push({ name: "homepage" })
      .then(() => {
        $vm.$modal.hideAll();
        logoutCallback();
      })
      .catch(() => {});
  }

  function doLogout(logoutCallback = () => {}) {
    isLoggingOut.value = true;

    const config = { DISABLE_ERROR_INTERCEPTORS: true };
    const url = $vm.$apiUrl("logout");

    axios
      .get(url, config)
      .then(() => refreshState())
      .then(() => processLogout(logoutCallback))
      .catch((error) => {
        notifyError();
        logError("Unable to logout user: " + error.message);
      })
      .finally(() => {
        isLoggingOut.value = false;
      });
  }

  /**
   * Asynchronous logout.
   */
  async function asyncLogout() {
    isLoggingOut.value = true;

    const config = { DISABLE_ERROR_INTERCEPTORS: true };
    const url = $vm.$apiUrl("logout");

    try {
      await axios.get(url, config);
      await refreshState();
      processLogout();
    } catch (error) {
      throw error;
    } finally {
      isLoggingOut.value = false;
    }
  }

  return {
    isLoggingOut,
    doLogout,
    asyncLogout,
  };
}
